import { Button, Col, Form, Modal, Row } from "react-bootstrap";
import React, { useContext, useState } from "react";
import { AuthContext } from "../../helpers/AuthContext";

export const ModalErrorReport = ({
  toggleFilter,
  showFilter,
  loading,
  mandateInfo
}) => {

  return (
    <Modal
      show={showFilter}
      onHide={toggleFilter}
      backdrop="static"
      keyboard={false}
      size="lg"
    >
        <Modal.Header closeButton>
                <div>
                  <Modal.Title>Error responses</Modal.Title>
                </div>
              </Modal.Header>
      <Modal.Body>
        {mandateInfo?.error_breakdown?.map((each, index) => <div key={index} style={{display: "flex", justifyContent: "space-between", marginTop: "10px", padding: "5px 8px", borderRadius: "5px", backgroundColor: "#F5F5F5"}}>
            <p style={{marginBottom: "0px"}}>Error code: {each?.errorCode}</p>
            <p style={{marginBottom: "0px", maxWidth: "300px", textAlign: 'center'}}>{each?.errorMessage}</p>
            <p style={{marginBottom: "0px"}}>Count: {each?.count}</p>
        </div>)}
      </Modal.Body>
      <Modal.Footer style={{ display: 'flex', justifyContent: 'flex-end' }}>
        <Button
          style={{
            backgroundColor: "red",
            fontSize: "0.8rem",
            fontWeight: 500,
          }}
          onClick={toggleFilter}
          disabled={loading}
        >
          {loading ? "Loading..." : "Cancel"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
